import React, { useState } from "react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useForm } from "react-hook-form";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import DialogContentText from '@material-ui/core/DialogContentText';

import { verifyCompanyOrgNumber, verifyPersonNumber, validString, validateEmail } from "../application/validation";


const submitForm = async (form) => {
    const response = await fetch("Partner/NewPartner", {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
        },
    });
    if (response.ok) return response;
    if (response.status === 401) {
        return Promise.reject("Unauthorized");
    }
    const json = await response.json();
    return Promise.reject(json);
};


export default function FormDialog() {
    const [open, setOpen] = useState(false);
    const [approved, setApproved] = useState(false);
    const [applicantType,setApplicantType] = useState('');

    const { register, errors, handleSubmit, formState} = useForm({
        mode: "onChange",
    });

    const onSubmit = values => {

        values['applicantType'] = applicantType;

        const response = submitForm(values);
        alert("Din anmälan är skickad");
        handleClose();

    }

    const { isValid } = formState;

    const handleChange = (event) => {
        setApproved(event.target.checked);
    };

    const handleChangeRadio = (event) => {
        setApplicantType(event.target.value);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleClickOpen}>
               Partneranmälan
      </Button>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                    <DialogContent>
                        <DialogContentText>
                           Fyll i uppgifterna nedan och skicka in anmälan. Vi kommer därefter att lägga upp er i vårt register.
 Så snart detta är klart kommer vi att skicka en bekräftelse till angiven e-postadress. Ni kommer därefter kunna logga in enkelt med ert organisationsnummer.
          </DialogContentText>
                        <Grid container item xs={12} spacing={2}>
                            <Grid key={1} item xs={12} sm={6}>
                                <TextField
                                    label="Organisationsnummer"
                                    variant="outlined"
                                    margin="dense"
                                    name="partnerIdentity"
                                    required
                                    fullWidth={true}
                                    inputRef={register({
                                        required: "Obligatoriskt",
                                        validate: (v) => verifyCompanyOrgNumber(v) || verifyPersonNumber(v) || "Ogiltigt organisations eller personnummer",
                                    })}
                                    error={!!errors?.partnerIdentity}
                                    helperText={errors?.partnerIdentity?.message}
                                />
                            </Grid>
                            <Grid key={2} item xs={12} sm={6}>
                                <TextField
                                    margin="dense"
                                    name="mChain"
                                    label="Mäklarkedja/Driftsnamn"
                                    variant="outlined"
                                    fullWidth={true}
                                    inputRef={register()}
                                />
                            </Grid>
                            <Grid key={3} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="companyName"
                                    label="Företagsnamn"
                                    variant="outlined"
                                    fullWidth
                                    inputRef={register()}
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={4} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="officenr"
                                    label="Kontorsnr"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid key={5} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="adress"
                                    label="Adress"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={6} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="postcode"
                                    label="Postnummer"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={7} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="city"
                                    label="Postort"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={8} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="email"
                                    label="Epost - Kontor"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt",
                                        validate: (v) => validateEmail(v) || "Ogiltig e-post adress",
                                    })}
                                    error={!!errors?.email}
                                    helperText={errors?.email?.message}
                                />
                            </Grid>
                            <Grid key={9} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="phone"
                                    label="Telefon - Kontor"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={10} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="contactPerson"
                                    label="Kontaktperson – kontor"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    inputRef={register({
                                        required: "Obligatoriskt"
                                    })}
                                />
                            </Grid>
                            <Grid key={11} item xs={12} sm={6}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    name="brokersystem"
                                    label="Mäklarsystem"
                                    variant="outlined"
                                    fullWidth
                                    inputRef={register()}
                                />
                            </Grid>
                            <Grid key={12} item xs={12}>
                                <FormControl component="fieldset" required inputRef={register}>
                                    <FormLabel component="legend">Verksamhet</FormLabel>
                                    <RadioGroup aria-label="gender" name="applicantType" value={applicantType} onChange={handleChangeRadio}>
                                        <FormControlLabel value="Fastighetsmäklare, medlem i Mäklarsamfundet" control={<Radio />} label="Fastighetsmäklare, medlem i Mäklarsamfundet" />
                                        <FormControlLabel value="Fastighetsmäklare, medlem i FMF" control={<Radio />} label="Fastighetsmäklare, medlem i FMF" />
                                        <FormControlLabel value="Besiktningsman, medlem i SBR" control={<Radio />} label="Besiktningsman, medlem i SBR" />
                                        <FormControlLabel value="Besiktningsman, fristående" control={<Radio />} label="Besiktningsman, fristående" />
                                        <FormControlLabel value="Annan verksamhet" control={<Radio />} label="Annan verksamhet" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid> 
                            <Grid key={13} item xs={12}>
                                <a href={process.env.PUBLIC_URL + "/Documents/200610 TOBA_DF_till webb_final.pdf"} target="_blank">Allmänna leveransvillkor</a> 
                            </Grid> 
                            <Grid key={14} item xs={12}>
                                <a href={process.env.PUBLIC_URL + "/Documents/Anti-Bribery and Corruption Policy - Swedish.pdf"} target="_blank">Policy mot mutor och korruption</a>
                            </Grid> 
                            <Grid key={15} item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox onChange={handleChange} name="approveTerms" />}
                                    label="Jag har tagit del av och bekräftar förutsättningarna i enlighet med Allmänna leveransvillkor samt Policy mot mutor och korruption"
                                    color="primary"
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} variant="contained" color="primary">
                            Avbryt
                    </Button>
                        <Button color="primary" disabled={(!isValid || !approved || applicantType =='')} variant="contained" type="submit">
                            Skicka anmälan
                    </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}